import React, { useState, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import Box from '@material-ui/core/Box'
import { IconButton, Link, Button } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import DeleteIcon from '@material-ui/icons/Delete'
import { HeaderTableCell } from '../containers'
import ApiClient from '../../common/ApiClient'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch } from 'react-redux'
import { OPEN_ALERT } from '../../redux/alertReducer'

export default function EntitlementUsersTableForContainerHub({
  entitlementId,
  users,
  isLoading,
  setNeedsFetchData,
  entitlement,
}) {
  const { getAccessTokenSilently } = useAuth0()
  const dispatch = useDispatch()
  const [loadingEmail, setLoadingEmail] = useState(null)

  useEffect(() => {
    setLoadingEmail(null)
  }, [users])

  const unassign = (email) => async () => {
    if (loadingEmail) return
    const showError = () =>
      dispatch({
        type: OPEN_ALERT,
        msg: 'Error occurred and the user has not been unassigned.',
        severity: 'error',
        action: (
          <Link href="mailto:SMB-myAdvantest-Admin@advantest.com">
            <Button variant="contained" color="primary" size="small">
              Contact support
            </Button>
          </Link>
        ),
      })
    setLoadingEmail(email)
    const token = await getAccessTokenSilently()
    await ApiClient.delete(`/v2/assignment?application=${entitlement.application}`, token, {
      entitlementId,
      email,
      isAdmin: false,
    })
      .then((response) => {
        if (response && response.status === 200) {
          setNeedsFetchData(true)
          dispatch({
            type: OPEN_ALERT,
            msg: `User (${email}) has been unassigned from the entitlement.`,
            severity: 'success',
          })
        } else {
          showError()
          setLoadingEmail(null)
        }
      })
      .catch(() => {
        showError()
        setLoadingEmail(null)
      })
  }

  const columns = [
    {
      name: 'email',
      label: 'Email',
      options: {
        customHeadRender: () => (
          <HeaderTableCell key="email">Email</HeaderTableCell>
        ),
      },
    },
    {
      name: 'unassignUser',
      label: 'Unassign',
      options: {
        customHeadRender: () => (
          <HeaderTableCell key="unassignUser">Unassign</HeaderTableCell>
        ),
        customBodyRenderLite: (dataIndex) => {
          const email = users[dataIndex].email
          return (
            <IconButton
              onClick={unassign(email)}
              color="primary"
              disabled={loadingEmail !== null}
            >
              {loadingEmail === email ? (
                <CircularProgress size={20} />
              ) : (
                <DeleteIcon />
              )}
            </IconButton>
          )
        },
      },
    },
  ]

  const options = {
    elevation: 4,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    print: false,
    filter: false,
    viewColumns: false,
    count: users.length,
    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress size={30} />
        ) : (
          'Sorry, there is no matching data to display'
        ),
      },
    },
  }

  return (
    <Box sx={{ marginTop: '8px' }}>
      <MUIDataTable
        style={{ marginTop: '8px' }}
        key="EntitlementUsers"
        title={'Users'}
        data={users}
        columns={columns}
        options={options}
      />
    </Box>
  )
}